/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { createSelector } from 'reselect';
import { workspaces as useWorkspaces } from '../../casing/data/feature.flags';
import { filterEnabledPlugins, selectPluginsListType } from './plugin.selectors';
import { selectOrgViewPlugins, selectSessionViewPlugins, selectUserViewPlugins } from './settings.selectors';
import { selectActiveWorkspaceViewPlugins } from './workspace.selectors';

export const selectAllViewPlugins = selectPluginsListType('view');

const selectEnabledViews = createSelector(
  selectSessionViewPlugins,
  selectUserViewPlugins,
  selectOrgViewPlugins,
  useWorkspaces,
  selectActiveWorkspaceViewPlugins,
  (session, user, org, usingWorkspaces, workspaceViews) => (
    usingWorkspaces ? workspaceViews
      : session && session.length ? session
        : user && user.length ? user : org
  )
);

export const selectEnabledViewPlugins = createSelector(
  selectAllViewPlugins,
  selectEnabledViews,
  filterEnabledPlugins
);
